import { Component } from '@angular/core';
import { FormControl } from '@angular/forms';

import { Subject } from 'rxjs';

@Component({
  selector: 'recruitee-link-input',
  templateUrl: './link-input.component.html',
  styleUrls: ['./link-input.component.less'],
  host: {
    '[class.context-alt]': 'true',
  },
})
export class LinkInputComponent {
  public exit = new Subject();
  public removeLink = new Subject();
  public formControl = new FormControl();
}
